
<form @submit.prevent="post" class="ui form" :class="{'warning': form.hasErrors()}">
  <app-message :msg="form.appMessage"></app-message>
  <div class="ui stacked segment">
    <div class="field">
      <div class="ui left icon input">
        <i class="user icon"></i>
        <input v-model="form.model.login_id" type="text" :placeholder="'ログインID'" autofocus>
      </div>
      <validation-message :form="form" :field="'login_id'"></validation-message>
    </div>
    <div class="field">
      <div class="ui left icon input">
        <i class="lock icon"></i>
        <input v-model="form.model.password" type="password" placeholder="パスワード">
      </div>
      <validation-message :form="form" :field="'password'"></validation-message>
    </div>
    <button type="submit" class="ui fluid teal submit button" :class="{'loading disabled': form.waiting}">ログイン</button>
  </div>
</form>
